module.exports = __webpack_public_path__ + "media/fonts/ArchivoNarrow-Bold-8b406ed1.ttf";